module.exports = __webpack_public_path__ + "960bb8f6612415c21465be3d0527f271.jpg";